/*
 * Ted&Co — "Order now" straight to checkout.
 * Builds a cart permalink for the selected variant + quantity and navigates to it,
 * bypassing the cart drawer and the /cart page:
 *   {cart_url}/{variant_id}:{qty}                    (standard Shopify checkout)
 *   {cart_url}/{variant_id}:{qty}?payment=shop_pay   (optional Shop Pay / shop.app)
 * Default is standard checkout (guest) — Shop Pay's "Sign in" is a mobile friction.
 * cart_url comes from Liquid (routes.cart_url) so locale prefixes (/fr) are kept.
 */
(function () {
  if (window.__tedDirectCheckout) return;
  window.__tedDirectCheckout = true;

  function currentVariantId(btn) {
    var scope = btn.closest('xo-product') || btn.closest('[data-ted-sp]') || document;
    var input = scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    var fromInput = input && input.value;
    var fromUrl = new URLSearchParams(window.location.search).get('variant');
    return btn.getAttribute('data-variant-id') || fromInput || fromUrl;
  }

  function currentQty(btn) {
    var root = btn.closest('[data-ted-sp]') || document;
    var input = root.querySelector('.ted-sp__qty input[name="quantity"]');
    var qty = parseInt(input && input.value, 10);
    return qty > 0 ? qty : 1;
  }

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('[data-ted-direct-checkout]');
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      if (btn.getAttribute('aria-disabled') === 'true') return;

      var id = currentVariantId(btn);
      if (!id) return;
      var cartUrl = (btn.getAttribute('data-cart-url') || '/cart').replace(/\/$/, '');
      var url = cartUrl + '/' + encodeURIComponent(id) + ':' + currentQty(btn);
      if (btn.getAttribute('data-shop-pay') === 'true') url += '?payment=shop_pay';

      btn.setAttribute('aria-busy', 'true');
      window.location.href = url;
    },
    true
  );

  // Back/forward cache: clear the busy state when the page is restored.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-ted-direct-checkout][aria-busy]').forEach(function (b) {
      b.removeAttribute('aria-busy');
    });
  });
})();
